import src from "IMAGE";
export default { src, width: 242, height: 242, blurWidth: 0, blurHeight: 0};
